module.exports = __webpack_public_path__ + "img/zgtitle.d6a7998b.png";